import { Parameter } from '@angular/fire/compat/remote-config';
import { environment } from '../../../environments/environment';
import * as actions from './remote-config.actions';

// :Note: If introducing a remote config variable on Firebase, please update:
// * The RemoteConfigState interface (below)
// * The default environment values (Environment.ts)
export interface RemoteConfigState {
  feed_version: number;
  memoriam_music_options: string[];
  new_community_page: boolean;
  new_home_screen: boolean;
  new_workflow_gallery: boolean;
  new_workflow_note: boolean;
  show_config_list: boolean;
  web_access_all_customers: boolean;
  web_announcements_cards_on_feed: boolean;
  web_announcements_featuredImage: boolean;
  web_announcements_headline: boolean;
  web_announcements_new_list: boolean;
  web_archive_customer: boolean;
  web_checkin_tag: boolean;
  web_list_notifications: boolean;
  web_add_phone_number: boolean;
  preferred_countries: string[];
  web_self_role: boolean;
  web_customer_lists: boolean;
  web_family_representative: boolean;
  web_configure_2fa: boolean;
}

// :Note: If any environment variables are found to have values of an incorrect
// type, this will throw a type conversion error.
const INITIAL_STATE: RemoteConfigState = environment.firebase.remoteConfig;

export function reducer(state: RemoteConfigState = INITIAL_STATE, action: actions.SetRemoteConfig) {
  switch (action.type) {
    case actions.SET_REMOTE_CONFIG:
      return SetRemoteConfigValue(action.payload, state);
    default:
      return state;
  }
}

// Casts a given Firebase Parameter to the type found in our environment values.
function SetRemoteConfigValue(value: Parameter, oldState: RemoteConfigState) {
  const newState: RemoteConfigState = { ...oldState };
  if (value.key in environment.firebase.remoteConfig) {
    switch (typeof environment.firebase.remoteConfig[value.key]) {
      case 'string':
        newState[value.key] = value.asString();
        break;
      case 'number':
        newState[value.key] = value.asNumber();
        break;
      case 'boolean':
        newState[value.key] = value.asBoolean();
        break;
      case 'object':
        newState[value.key] = JSON.parse(value.asString());
      default:
        // There exists a case where incoming keys won't match our existing
        // data. This could be because of remote config keys for other
        // platforms. Because of this, we ignore the incoming data.
        break;
    }
  }
  return newState;
}
